<template>
  <div class="arrival-table">
    <form class="arrival-table__head">
      <div class="arrival-table__cell">Дата</div>
      <div class="arrival-table__cell">Автор</div>
      <div class="arrival-table__cell">Поставщик</div>
      <div class="arrival-table__cell">Итоговая стоимость</div>
    </form>
    <div class="arrival-table__body-mobile">
      <button
        class="arrival-table__body-mobile__button-row"
        type="button"
        v-for="({
          id,
          date,
          author,
          vendor,
          amount,
        }) in arrivalList"
        v-bind:key="id"
        v-on:click="onEditArrival(id)">
        <dl class="arrival-table__body-mobile__row">
          <dt>Дата</dt>
          <dd>{{ date }}</dd>
          <dt>Автор</dt>
          <dd>{{ author }}</dd>
          <dt>Поставщик</dt>
          <dd>{{ vendor }}</dd>
          <dt>Итоговая стоимость</dt>
          <dd>{{ getProcessedAmount(amount) }}</dd>
        </dl>
      </button>
    </div>
    <div
      v-if="!this.isArrivalListEmpty && !this.isAwaitRequest"
      class="arrival-table__body"
    >
      <button
        class="arrival-table__row"
        type="button"
        v-for="({
          id,
          date,
          author,
          vendor,
          amount,
        }) in arrivalList"
        v-on:click="onEditArrival(id)"
        v-bind:key="id">
        <div
          data-label="Дата"
          class="arrival-table__cell">
          {{ date }}
        </div>
        <div
          data-label="Автор"
          class="arrival-table__cell">{{ author }}</div>
        <div
          data-label="Поставщик"
          class="arrival-table__cell">{{ vendor }}</div>
        <div
          data-label="Итоговая стоимость"
          class="arrival-table__cell">{{ getProcessedAmount(amount) }}</div>
        <div
          data-label="Редактировать"
          class="arrival-table__cell"
        >
          <button
            class="arrival-table__icon-edit"
            type="button"
            v-on:click.prevent.stop="onEditArrival(id)" />
        </div>
        <div
          data-label="Удалить"
          class="arrival-table__cell">
          <button
            class="arrival-table__icon-delete"
            type="button"
            v-on:click.prevent.stop="onDeleteArrival(id)" />
        </div>
      </button>
    </div>
    <div
      v-else-if="!isAwaitRequest"
      class="arrival-table__message"
    >
      Ничего не найдено
    </div>
  </div>
</template>
<script>

/**
 * @description Таблица приходов.
 * @type {any}
 */
export default {
  computed: {
    /**
     * @description Является ли список приходов пустым.
     * @returns {boolean}
     */
    isArrivalListEmpty() {
      return !Object.keys(this.arrivalList).length;
    },
  },
  methods: {
    /**
     * @description Обработать удаление прихода.
     * @param {number} id Идентификатор прихода.
     * @returns {void}
     */
    onDeleteArrival(id) {
      this.$emit('delete-arrival', id);
    },
    /**
     * @description Обработать редактирование прихода.
     * @param {number} id Идентификатор прихода.
     * @returns {void}
     */
    onEditArrival(id) {
      this.$emit('edit-arrival', id);
    },
    /**
     * @description Обработать вывод итоговой стоимости.
     * @param {string} value Итоговая стоимость.
     * @returns {string}
     */
    getProcessedAmount(value) {
      return value
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ');
    },
  },
  props: {
    /**
     * @description Список приходов.
     * @type {any[]}
     */
    arrivalList: { type: Array, required: true },
    /**
     * @description Ожидание завершения запроса.
     * @type {boolean}
     */
    isAwaitRequest: { type: Boolean, required: true },
  },
};
</script>
<style lang="scss">

.arrival-table {
  margin: 25px 0 0 0;
  &__body-mobile {
    display: none;
    flex-direction: column;
    gap: 10px;
    &__button-row {
      &:nth-child(odd) {
        background-color: var(--fill-color);
      }
    }
    &__row {
      display: grid;
      font-size: 12px;
      grid-template-columns: auto 1fr;
      justify-items: flex-end;
      align-items: center;
      row-gap: 5px;
      padding: 5px;
      & > dt {
        justify-self: flex-start;
      }
      & > dd {
        text-align: right;
      }
    }
  }
  &__head,
  &__row {
    width: 100%;
    display: grid;
    grid-template-columns:
      minmax(100px, 200px)
      repeat(3, 1fr)
      repeat(2, 43px);
    align-items: center;
    font-size: 14px;
    line-height: 17px;
  }
  &__head {
    font-weight: 700;
    border-bottom: 2px solid #0489e0;
    text-align: center;
  }
  &__row {
    border-bottom: 1px solid #eaeff3;
    padding: 0;
    &:hover {
      background: #eaeff3;
    }
  }
  &__cell {
    padding: 12px 8px;
    transition: color var(--animate-duration);
    .theme--light.v-icon:focus:after {
      opacity: 0;
    }
  }
  &__message {
    text-align: center;
    padding-top: 40px;
    font-size: 24px;
  }
  &__icon {
    &-edit {
      display: block;
      background-image: url("@/assets/img/pen-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 14px;
      height: 14px;
      padding: 0;
      margin: 0;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/pen-blue.svg");
      }
    }
    &-delete {
      display: block;
      background-image: url("@/assets/img/exit-grey.svg");
      background-size: contain;
      background-repeat: no-repeat;
      width: 12px;
      height: 12px;
      cursor: pointer;
      &:hover {
        background-image: url("@/assets/img/exit-blue.svg");
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .arrival-table {
    &__head,
    &__row {
      grid-template-columns: repeat(4, 1fr) repeat(2, 43px);
      font-size: 12px;
      line-height: 17px;
    }
  }
}
@media screen and (max-width: 1100px) {
  .arrival-table {
    &__head {
      display: none;
    }
    &__row {
      grid-template-columns: 1fr;
      grid-gap: 10px;
      margin: 0 0 20px 0;
    }
    &__cell {
      display: flex;
      justify-content: space-between;
      text-align: right;
      padding: 0;
    }
    &__cell::before {
      content: attr(data-label);
      font-weight: 700;
      margin-right: 20px;
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 480px) {
  .arrival-table__body {
    display: none;
    &-mobile {
      display: flex;
    }
  }
}

.items-table {
  margin-top: 10px;
}
.items-header,
.items-row {
  display: flex;
  justify-content: space-between;
  padding: 5px 0;
  border-bottom: 1px solid #ddd;
}
.items-header {
  font-weight: bold;
}
</style>
